import { defineComponent as o, openBlock as a, createElementBlock as l, normalizeClass as n, renderSlot as i } from "vue";
import { _ as c } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
import './css/Column.css';const r = /* @__PURE__ */ o({
  __name: "Column",
  props: {
    /**
     * The width of the column.
     * On tablet and mobile, the column will take up the full width.
     *
     * @default 'auto'
     */
    width: {
      type: String,
      default: "auto"
    },
    /**
     * The rotation of the column.
     *
     * @default 'rotate-0'
     */
    rotation: {
      type: String,
      default: "rotate-0"
    },
    /**
     * Specifies whether to fill the entire column space with a cover image.
     * This option is only usable with a single child element, which must be an image.
     *
     * @default false
     */
    fill: {
      type: Boolean,
      default: !1
    },
    /**
     * Specification to be written
     *
     * @default 'static'
     */
    sticky: {
      type: String,
      default: "static"
    }
  },
  setup(t) {
    return (e, s) => (a(), l("div", {
      class: n(["column", [
        `column-${t.width}`,
        t.rotation,
        t.sticky !== "static" ? "sticky " + t.sticky : "",
        `rotate-${t.rotation}`,
        `column-${t.fill ? "fill" : "default"}`
      ]])
    }, [
      i(e.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), d = /* @__PURE__ */ c(r, [["__scopeId", "data-v-94272487"]]);
export {
  d as default
};
